import React from "react";
import BaseModal from "./BaseModal";

function DeleteQuestionModal(props) {
    return props.modalShown ?
        (
            <BaseModal modalId={"myModal"} modalClass={"modal"} innerDivClass={"modal-content"}>
                <span className="close" onClick={props.closeModal}>&times;</span>
                <div className="modal-content__title modal-content__title--center">Delete question?</div>
                <div className="modal-content__actions modal-content__actions--center">
                    <a href="#" className="modal-content__actions__btn"
                       onClick={(e) => {e.preventDefault();props.deleteAction()}}>Yes</a>
                    <a href="#" className="modal-content__actions__btn modal-content__actions__btn--filledBlue"
                       onClick={(e) => {e.preventDefault();props.closeModal()}}>No, go back</a>
                </div>
            </BaseModal>
        ) : null;
}

export default DeleteQuestionModal;